import { createIntl, createIntlCache } from '@formatjs/intl'

export const messages = {
  en: {
    // Home page
    'home.title': 'K STADIUM Ground Chain Explorer',
    'home.subTitle': 'Block explorer and analytics platform for K STADIUM',
    'home.chartTitle': 'Daily Transactions History In 14 Days',
    'home.listTitle': 'Latest Blocks',

    // error message
    'error.failTotalNum': 'Failed to get total count. please try again',
    'error.failAccountBalance':
      'No data received: It is recommended not to load this page until this problem is resolved.',
    'error.failAccountTokens': 'Failed to get account tokens. please try again',
    'error.failData': 'Failed to get Data. please try again',
  },
}

const cache = createIntlCache()

const intl = createIntl(
  {
    locale: 'en',
    messages: messages.en,
  },
  cache,
)

const translate = (id: string, values?: object) => {
  return intl.formatMessage({ id }, values)
}

export default translate
